function isMobile() {
	const isMobile = window.matchMedia('(max-width: 767px)').matches

    return isMobile
}

function isTablet() {
	const isTablet = window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches

    return isTablet
}
function isDesktop() {
	const isDesktop = window.matchMedia('(min-width: 1025px)').matches

    return isDesktop
}
isDesktop()

function isSafari(){
    return navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
}


export {
    isMobile,
    isTablet,
    isDesktop,
    isSafari
}
